<template>
    <ul :class="['articel_list']" ref="mouseWheelRf">
      <drop-down-refresh :onRefresh="onRefresh" source="p0" :dropDownInfo='{
        downText: "下拉可以加载",
        downImg: "arrow.png",
        upText: "松开立即加载",
        upImg: "arrow.png",
        refreshText: "正在加载数据...",
        refreshImg: "loading.png",
      }'>
        <no-data msg="没有更多数据了" v-if="pageLoaded"></no-data>
  
        <SkeletonScreen :data="5" v-show="!isCloseSkeletonScreen ||  (pageLoading && articel_list.length === 0)  " />
  
        <template v-for="(item, i) in articel_list">
          <li
            v-if="item._time_firDate && item._time_firDateStamp && item.State != 2"
            :key="item.message_dialogue_time"
            class="message_dialogue_time"
            :data-time="item._time_firDate"
            :id="'made_' + item.id"
          ></li>
          <circleListItem
            v-if="item.State != 2"
            :circleData="circleData"
            :type="'app_circle'"
            :key="item.id"
            :msg="item"
            :index="i"
            :IsBlacklist="IsBlacklist"
            tagType="聊天室"
            :user_id="user_id"
            @chattingClick="chattingClickFn"
            :showChattingIndex="showChattingIndex"
            :isCloseInteraction="false"
            :liveDefault="liveDefault"
            :isAdmins="isAdmins"
          />
        </template>
      </drop-down-refresh>
    </ul>
  </template>
  <script>
  import { u_id, token, appversion, source, change_bgImg, textSize } from "@/utils/urlQuery";
  import circleListItem from "@/page/appProfiles/components/circleListItem.vue";
  import dropDownRefresh from "@/page/appProfiles/components/dropDownRefresh.vue";
  import circleApi from "@/api/circle/index.js";
  import noResult from "@/page/appProfiles/components/no-result";
  import noData from "@/components/noData"
  import loading from "@/components/loading"
  // import banner from "@/page/appProfiles/components/banner";
  export default {
    name: "chattingRoomForUser",
    data() {
      return {
        articel_list: [],
        isCloseSkeletonScreen: false,
        // 页面载入情况
        pageLoaded: false,
        pageLoading: false,
        showChattingIndex: null,
        pageId: null,
        circleData: {},
        user_id: 0,
        id: Number(this.$route.params.chat_room_live_id || 124), // 圈子ID TODO edit_3
        forUserId: this.$route.params.userId, // 查看该用户的id
        forUserName: this.$route.params.userNick, // 查看该用户的名字
        hasMore: false,
        IsBlacklist: 0, //审核状态 1为审核中，可拉黑
        commentContent: "",
        comIptInfo: "我也来聊两句…",
        focus_ipt: false,
        isIphonXSeries: this.$isIphonXSeries(),
        // at 用户信息
        atUserName: "",
        atUserId: "",
        atUserContent: "",
        ispublish: false,
        Vim: null,
        is_show_bottom_tip: false,
        // 只看圈主
        only_master_type: false,
        isAdmins: false,
        chattingRoomStyle: "",
  
        pushToUser: false, // 推送给用户
  
        hasBannerData: false,
        liveDefault: "list_msg",
        userInfo: {},
      }
    },
    components: {
      circleListItem,
      dropDownRefresh,
      noResult,
      noData,
      loading
      // banner
    },
    created() {
        this.user_id = u_id;
        this.userInfo = { // 当前登录老师的信息
            user_app_token: token,
        };

        // 获取圈子列表
        this.getCircleInfo({ forum_id: this.id }, () => {

            this.getChattingRoom();
        })
    },
    mounted() {
      let _this = this;

      let _title = this.forUserName + "的所有发言"
      document.title = _title;
  
      this.pushToUser = this.hasSaveInfo("pushToUserType_" + this.id);
  
      $(document).scroll(function () {
        let scroH = $(document).scrollTop();  //滚动高度
        let viewH = $(window).height();  //可见高度 
        let contentH = $(document).height();  //内容高度
  
        if (contentH < (scroH + viewH + 200)) {  //滚动条滑到底部啦
          _this.is_show_bottom_tip = false;
        }
      });
    },
    methods: {
      // 获取用户聊天室的权限
      getChattingInfo(type) {
        let _this = this;
        let result = res.data;
        localStorage['ChattingToken'] = result;
  
        if (type == '_refresh') {
          _this.Vim && _this.Vim.reconnect && _this.Vim.reconnect()
        }
      },
      // 获取圈子信息
      async getCircleInfo(opt, c) {
        // TOOD edit_2
        // let res = await circleApi.getCircleData(opt);
        let res = {}
        if (res.status === "success" || true) {
          let result = {
            chat_banned_to_post: 0, // 禁言状态
            user_id: 44324, // 圈主ID
            master: 1, // 是否为老师
            id: this.id, // 聊天室ID
            chat_room_style: 0, // 聊天室类型
            name: "聊天室昵称", // 聊天室昵称
          };
          this.circleData = result;
  
          // 聊天室类型
          this.chattingRoomStyle = result.chat_room_style == 1 ? 'live' : 'comment';
  
          let isAdmins = false;
          let userInfo = this.userInfo;
  
          if(userInfo && userInfo.l_id == this.id) {
              isAdmins = true
          }
  
          this.isAdmins = isAdmins;
  
  
          if (!isAdmins && result.chat_banned_to_post == 1 ? true : false) {
            this.comIptInfo = "全体禁言中"
          }
  
          c && c();
        } else {
          this.$message.error(res.message);
        }
      },
      // 下拉刷新
      async onRefresh(refreshDone) {
        this.pageLoading = true;
  
        await this.getChattingRoom(this.pageId);
        refreshDone();
      },
      // 聊天室点击事件
      chattingClickFn(obj) {
        console.info(obj.item, obj.index, obj.type)
  
        // 删除 撤回
        if (obj.type == 'delItem') {
          this.articel_list.splice(obj.index, 1);
          this.showChattingIndex = null;
        }
        // 点击某项展示 列表
        else if (obj.type == 'showTab') {
          if (this.showChattingIndex == obj.index) {
            this.showChattingIndex = null;
          } else {
            this.showChattingIndex = obj.index;
          }
        }
        // 回复某位用户
        else if (obj.type == 'reply_user') {
          this.replayUserFn(obj.item);
          this.handleClickComment();
        }
        // 关闭item
        else if (obj.type == 'closeItem') {
          this.showChattingIndex = null;
        }
      },
      // 获取聊天室列表
      async getChattingRoom(before_id) {
        this.pageLoading = true;
        let _this = this;
        let data = {
          chat_room_live_id: this.id,
          user_id: this.user_id,
          limit: 20,
        }
        data.show_user_id =  this.forUserId;
        console.info('a1?')
  
        if (before_id) {
          data.before_id = before_id;
        }
  
        let res = await circleApi['get_chat_list'](data)
  
        if (res.code === 1) {
          let result = res.data && res.data.reverse();
  
          let _firstDom = $(
            ".articel_list li.message_dialogue_time"
          ).first();
  
          let _id = "" + $(_firstDom).attr('id')
  
          if (result && result.length > 0) {
  
            let _firData = new Date();
            if (result.length > 0) {
              let _date = result[0].create_time;
              _firData = new Date(_date.replace(/-/g, '/')).getTime();
              result[0]._time_firDate = _firData;
              result[0]._time_firDateStamp = _this.timeStamp(_date);
            }
  
            for (var i in result) {
              var qa = result[i];
              let item_date = qa.create_time;
              let qaDate = new Date(item_date.replace(/-/g, '/')).getTime()
              if (i > 0 && _firData * 1 + 600 * 1000 < qaDate) {
                _firData = qaDate;
                result[i]._time_firDate = qaDate;
                result[i]._time_firDateStamp = _this.timeStamp(item_date);
              }
            }
  
            if (!before_id) {
              _this.articel_list = result;
            } else {
              _this.articel_list.unshift(...result);
            }
  
            _this.pageId = result[0].id;
          } else {
            if (!before_id) {
              _this.articel_list = [];
            }
            _this.pageLoaded = true;
          }
  
          if (!before_id) {
            _this.isCloseSkeletonScreen = true;
            // 滚动到底部
            _this.$nextTick(() => {
              $("html, body").scrollTop(999999999);
            })
          } else {
            if ((result && result.length == 0) || !result) {
              _this.pageLoaded = true;
            } else {
              _this.$nextTick(() => {
                document.location.replace(_this.getFilterUrl(_id));
  
                _this.pageLoading = false;
              })
            }
          }
        } else {
          _this.hasMore = false;
        }
        _this.pageLoading = false;
      },
      getFilterUrl(hash) {
        return document.location.protocol + '//' + document.location.host + document.location.pathname + document.location.search + '#' + hash;
      },
  
      // 实践方法
      timeStamp(data) {
        let _date = new Date(data.replace(/-/g, '/')),
          _now_date = new Date(),
          _today = new Date(
            _now_date.getFullYear(),
            _now_date.getMonth(),
            _now_date.getDate(),
            0,
            0,
            0,
            0
          ),
          _toyead = new Date(_now_date.getFullYear(), 0, 0, 0, 0, 0, 0);
  
        let _year = _date.getFullYear(),
          _month = _date.getMonth() + 1,
          _d = _date.getDate(),
          _h = _date.getHours(),
          _m = _date.getMinutes();
  
        if (_month < 10) {
          _month = "0" + _month;
        }
  
        if (_d < 10) {
          _d = "0" + _d;
        }
  
        if (_h < 10) {
          _h = "0" + _h;
        }
  
        if (_m < 10) {
          _m = "0" + _m;
        }
  
        // 今天的执行逻辑
        if (_date.getTime() > _today.getTime()) {
          return `${_h}:${_m}`;
        }
        // 今年的执行逻辑
        else if (_date.getTime() > _toyead.getTime()) {
          return `${_month}-${_d} ${_h}:${_m}`;
        }
        // 去年的执行逻辑
        else {
          return `${_year}-${_month}-${_d} ${_h}:${_m}`;
        }
      },
      handleClickComment() {
        if (this.focus_ipt || !this.isAdmins && this.circleData.chat_banned_to_post == 1 ? true : false) {
          return;
        }
        this.focus_ipt = true;
      },
      // 回复用户
      replayUserFn(item, index) {
        this.atUserName = item.nickname;
        this.atUserId = item.id;
        this.atUserContent = item.content;
      },
      // 关闭at用户
      closeAtFn() {
        this.atUserName = "";
        this.atUserContent = "";
        this.atUserId = "";
      },
      // 聊天室 - 发送内容
      async publishComment() {
        let _this = this;
        if (this.ispublish) {
          return;
        } else {
          this.ispublish = true;
          let content = this.commentContent;
          if (!content) {
            this.$message.error("请输入评论内容!");
            return (this.ispublish = false);
          }
          let data = {
            content,
            // user_id: this.user_id,
            chat_room_live_id: this.id,
            content_type: 1,
          };
  
          if (this.atUserName && this.atUserId) {
            data.origin_id = this.atUserId || 0;
          }
  
          if (this.isAdmins && this.pushToUser) {
            data.is_select_push = 1;
          }
  
          let res = await circleApi.send_message({
            ...data
          })
          if (res.code == 1) {
            _this.$message.success("发送成功");
  
            _this.focus_ipt = false;
            _this.commentContent = "";
            _this.ispublish = false;
            _this.showChattingIndex = null;
            _this.closeAtFn()
  
            let count = true;
            for (let i = 0, ilen = _this.articel_list.length; i < ilen; i++) {
              if (_this.articel_list[i].id == res.data.id) {
                count = false;
                break;
              }
            }
            if (count) {
              _this.articel_list.push(res.data);
            }
  
            _this.$nextTick(() => {
              $(_this.$refs['mouseWheelRf']).scrollTop(99999999999)
              $("html, body").scrollTop(99999999)
            })
          } else {
            _this.$message.error(res.message);
            _this.ispublish = false;
          }
        }
      },
      // 定位到底部
      fixedBottom() {
        $(this.$refs['mouseWheelRf']).scrollTop(99999999999)
        $("html, body").scrollTop(99999999)
        this.is_show_bottom_tip = false;
      },
      // 判断dom是否在可视区
      // 第一个参数是element  第二个参数是 是否部分可见也算可见  
      // 设置为false 即有一部份不可见即不可见
      // 设置为true 即部分可见即算是可见
      elementIsVisibleInViewport(el, partiallyVisible = false) {
        const {
          top,
          left,
          bottom,
          right
        } = el.getBoundingClientRect();
        const {
          innerHeight,
          innerWidth
        } = window;
        return partiallyVisible ?
          ((top >= 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
          ((left >= 0 && left < innerWidth) || (right > 0 && right < innerWidth)) :
          top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
      },
      // 查询某个存储值是否存在
      hasSaveInfo(keys) {
        let _type = ""
        if (localStorage && localStorage[keys]) {
          _type = localStorage[keys]
        } else {
          _type = "close_type"
        }
  
        if (_type == 'close_type') {
          return false;
        } else {
          return true;
        }
      },
      saveInfo(keys, value) {
        if (localStorage) {
          localStorage[keys] = value;
        }
      }
    }
  }
  </script>
  <style scoped lang="scss">
  .articel_list {
    background: #F5F6F7;
    padding-top: 6px;
    overflow: hidden;
    position: relative;
  
    &.paddingTop {
      padding-top: 42px;
    }
  
    .h_agq_page_chatting_wrap_nav {
      width: 100%;
      height: 60px;
      background-color: #fff;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
      padding: 10px 12px;
      box-sizing: border-box;
  
      div {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        border-radius: 20px;
        overflow: auto;
  
        button {
          flex: 1;
          color: #939393;
          font-size: 14px;
          height: 100%;
          background-color: transparent;
          font-weight: bold;
          border: none;
          padding: 0;
          margin: 0 3px;
          outline: none;
          cursor: pointer;
  
          &.bind_this {
            height: calc(100% - 6px);
            background-color: #fff;
            margin: 3px;
            border-radius: 17px;
          }
        }
      }
    }
  
    .pd_zw {
      padding-top: 60px;
    }
  
    .pd_zw_2 {
      padding-top: 80px;
    }
  
    .chattingRoom {}
  
    .h_agq_page_li {
      &:last-of-type {
        margin-bottom: 90px;
      }
    }
  
    .chattingRoomBox {
      width: 100%;
      height: 76px;
      background-color: #fcfcfc;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      padding: 6.5px 10px;
  
  
  
      .chattingRoomIpt {
        height: 36px;
        position: relative;
      }
  
      .chattingRoomBoxIpt {
        width: 100%;
        height: 100%;
        background-color: #F2F2F2;
        border-radius: 2px;
        font-size: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #939393;
        padding-left: 10px;
        box-sizing: border-box;
        user-select: none;
      }
  
      .chattingRoomBoxFace {
        width: 23px;
        height: 23px;
        position: absolute;
        right: 23.5px;
        top: 50%;
        transform: translateY(-50%);
  
        button {
          width: 23px;
          height: 23px;
          background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/face_app.svg");
          background-repeat: no-repeat;
          background-size: 23px 23px;
          background-color: transparent;
          border: none;
          outline: none;
        }
      }
    }
  
    .message_dialogue_time {
      width: 0;
      height: 0;
      overflow: hidden;
      visibility: hidden;
      opacity: 0;
    }
  
    // 撤回的消息样式
    .message_with_draw {
      width: 100%;
      height: auto;
      text-align: center;
      font-size: 12px;
      line-height: 16.5px;
      color: #888;
      padding: 10px 0;
      box-sizing: border-box;
    }
  }
  
  // 滚动到底部的提示
  .h_agq_page_bottom_tip {
    padding: 6px 26px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    background-color: #48A0FF;
    border-radius: 16.5px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 77.5px;
    cursor: pointer;
    user-select: none;
    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/down.svg");
    background-size: 10px 9.5px;
    background-position: 236px center;
    background-repeat: no-repeat;
    white-space: nowrap;
  }
  
  .publish_wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 20;
  
    .chattingRoomCheck {
      width: 100%;
      height: 27px;
      display: flex;
      align-items: center;
      background-color: #fff;
      padding-right: 10px;
      justify-content: flex-end;
      box-sizing: border-box;
  
      button {
        font-size: 12px;
        font-weight: normal;
        color: #636363;
        user-select: none;
        cursor: pointer;
        padding-left: 20px;
        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/check.svg");
        background-repeat: no-repeat;
        background-size: 13px 13px;
        background-color: transparent;
        background-position: left center;
        border: none;
        outline: none;
        cursor: pointer;
  
        &.bindThis {
          background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/checked.svg");
        }
  
        &.chatting_to_push_user {
          margin-right: 20px;
        }
      }
    }
  
    .publish_box {
      width: 100%;
      height: auto;
      background: #ffffff;
      padding: 5px 10px;
      box-sizing: border-box;
      border-top: 1px solid #dedfde;
      border-bottom: 1px solid #dedfde;
  
      .publish_at {
        background-color: #fff;
        font-size: 13px;
        line-height: 18.5px;
        color: #636363;
        margin-bottom: 6.5px;
        padding-right: 87px;
        box-sizing: border-box;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-height: 37px;
  
        button {
          background-image: url("https://cdncos.aigupiao.com/assets/pc/svg/agq_common/h_agq_close.svg");
          width: 18.5px;
          height: 18.5px;
          background-repeat: no-repeat;
          background-size: 10px 10px;
          background-position: center center;
          position: absolute;
          right: 68.5px;
          padding: 0;
          background-color: transparent;
          border: none;
          outline: none;
        }
      }
  
      .publish_box_flex {
        width: 100%;
        height: auto;
        display: flex;
        box-sizing: border-box;
  
        >.input_box {
          flex: 1;
          height: 40px;
          border: 1px solid #dcdddc;
          color: #939393;
          border-radius: 5px;
          overflow: hidden;
  
          >textarea {
            width: 100%;
            height: 100%;
            color: #939393;
            border-radius: 5px;
            font-size: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            border: none;
            outline: none;
            line-height: 40px;
            resize: none;
            background-color: #F2F2F2;
          }
  
          >div {
            width: 100%;
            height: 100%;
            color: #939393;
            border-radius: 5px;
            font-size: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            border: none;
            outline: none;
            line-height: 40px;
            resize: none;
            background-color: #F2F2F2;
          }
  
          &.focus_ipt {
            height: 80px;
  
            >textarea {
              line-height: 25px;
            }
          }
        }
  
        >.comment_wrap {
          width: 54px;
          padding: 0 0 12px 9px;
          box-sizing: border-box;
          display: none;
          align-self: flex-end;
  
          .comment_btn {
            width: 46px;
            height: 36px;
            background: #fe484a;
            border: 1px solid #fe484a;
            border-radius: 5px;
            text-align: center;
            line-height: 36px;
            color: #fff;
            font-size: 12px;
          }
        }
      }
  
      &.publish_box_focus {
        height: auto;
  
        .comment_wrap {
          display: flex;
        }
      }
    }
  
    .pad {
      background: #ffffff;
  
      &.is_iphonx_series {
        padding-bottom: 20px;
      }
    }
  }
  
  .publish_mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
  }
  </style>